<template>
    <div class="flex">
        <button class="layout-topbar-button text-lg" aria-haspopup="true" aria-controls="i18n_menu" @click="showLanguages">
            {{ currentLanguage.image }}
        </button>
        <Menu ref="menu" :model="AvailableLanguages" :pt="{ itemLink: '!text-[initial]' }" :popup="true">
            <template #item="{ item, props }">
                <a v-bind="props.action" @click="changeLocale(item.value)">
                    <span data-pc-section="label">{{ item.name }}</span>
                </a>
            </template>
        </Menu>
    </div>
</template>

<script lang="ts" setup>
    import Menu from 'primevue/menu'
    import { computed, onMounted, useTemplateRef } from 'vue'
    import { useI18n } from 'vue-i18n'

    import { AvailableLanguages, getLanguage } from '@/libs/language.ts'
    import { useAppStore } from '@/stores/app.ts'

    // data
    const appStore = useAppStore()

    const { locale } = useI18n()

    const menu = useTemplateRef<InstanceType<typeof Menu>>('menu')

    // computed
    const currentLanguage = computed(() => {
        return getLanguage(locale.value)
    })

    // methods
    const showLanguages = (event: Event) => {
        if (menu.value) menu.value.toggle(event)
    }

    const changeLocale = (newLocale: string) => {
        appStore.changeLocale(newLocale)

        if (menu.value) menu.value.hide()
    }

    // hooks
    onMounted(() => {
        changeLocale(localStorage.getItem('locale') || 'sl')
    })
</script>
